import http from "../http-common-3";
import IAssessmentData from "../types/Assessment.type";

class AssessmentDataService {
  getStatistics(date: string, token: any) {
    return http.get<Array<IAssessmentData>>(
      `orca/assessments/statistics?date=${date}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  downloadAllAssessments(token: any) {
    return http.get(`orca/assessments/json/data`, {
      responseType: "blob",
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  downloadLeadByExperts(token: any, expertName: any) {
    return http.get(
      `orca/assessments/csv/experts/lead?expertName=${expertName}`,
      {
        responseType: "blob",
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  getWorkshops(token: any) {
    return http.get<Array<IAssessmentData>>(`/workshops`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  postWorkshop(workshopdata: any, token: any) {
    return http.post<Array<IAssessmentData>>(`/workshops`, workshopdata, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  getSingleWorkshop(id: any, token: any) {
    return http.get<Array<IAssessmentData>>(`/workshops/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  updateSingleWorkshop(id: any, workshopdata: any, token: any) {
    return http.patch<Array<IAssessmentData>>(
      `/workshops/${id}`,
      workshopdata,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  deleteWorkshop(id: any, token: any) {
    return http.delete<Array<IAssessmentData>>(`/workshops/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  getDateRangesData(fromDate: string, toDate: string, token: any) {
    return http.get(
      `orca/assessments/analytics?fromDate=${fromDate}&toDate=${toDate}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  getPaymentLink(data: any, token: any) {
    return http.post(`orca/assessments/createpaymentlink`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getBasicPaymentLink(data: any, token: any) {
    return http.post(`orca/assessments/createbasicpaymentlink`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getPayments(pageSize: any, pageNo: any, token: any, expert?: any, email?: any) {
    return http.get(
      `paymentlinks?pageSize=${pageSize}&pageNo=${pageNo}&expert=${expert}&email=${email}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  deletePayments(token: any, id: any) {
    return http.delete(`paymentlinks/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getCsvData(fromdate: string = "", toDate: string = "", token: any) {
    return http.get(
      `orca/assessments/csv/issusecount?fromdate=${fromdate}&todate=${toDate}`,
      {
        responseType: "blob",
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getIntakeForm(fromdate: string = "", toDate: string = "", token: any) {
    return http.get(
      `orca/assessments/intakeform/statistics?fromdate=${fromdate}&todate=${toDate}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  getIntakeFormFourWeekData(token: any) {
    return http.get(`orca/assessments/intakeform/fourweekdata`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  getIntakeFormMonthlyData(token: any, type: any) {
    return http.get(`orca/assessments/intakeform/monthlydata?type=${type}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getCountByExpertData(
    token: any,
    startDate: any,
    endDate: any,
    leadStatus: any
  ) {
    return http.get(
      `orca/assessments/intakeform/countbyexpertdata?startDate=${startDate}&endDate=${endDate}&leadStatus=${leadStatus}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  sendMessage(data: any, token: any) {
    return http.post<any>("orca/assessments/sendWhatsappMessage", data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getIssueAnalytics(
    fromdate: string = "",
    toDate: string = "",
    issue: string,
    leadstatus: string,
    token: any
  ) {
    return http.get(
      `orca/assessments/analytics/issue?fromdate=${fromdate}&todate=${toDate}&issue=${issue}&leadstatus=${leadstatus}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
  getData(
    leadstatus: string,
    data: string,
    date: string,
    dateType: string,
    page: number,
    pageSize: number,
    isSort: string,
    ehcExpert: string,
    assessmentFlags: any,
    token: any
  ) {
    return http.get(
      `orca/assessments/search?leadstatus=${leadstatus}&search=${data}&date=${date}&dateType=${dateType}&pageSize=${pageSize}&page=${page}&isSort=${isSort}&ehcExpert=${ehcExpert}&assessmentFlags=${assessmentFlags}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getAssessmentData(page: number, pageSize: number, token: any) {
    return http.get(
      `orca/assessments/tests?pageSize=${pageSize}&page=${page}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  get(id: string, token: any) {
    return http.get<any>(`orca/assessments/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  create(data: IAssessmentData, token: any) {
    return http.post<IAssessmentData>("orca/assessments", data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  update(data: IAssessmentData, id: any, token: any) {
    return http.patch<any>(`orca/assessments/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateMarkStatus(markedAs: string, id: any, token: any) {
    return http.patch(
      `orca/assessments/update/markedstatus/${id}`,
      { markedAs },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  delete(id: any, token: any) {
    return http.delete<any>(`orca/assessments/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  login(data: any) {
    return http.post("/login", data);
  }

  getAllNgo(
    page: number,
    pageSize: number,
    search: string,
    leadStatus: string,
    token: any
  ) {
    return http.get(
      `/ngo?page=${page}&pageSize=${pageSize}&search=${search}&leadstatus=${leadStatus}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  addNgo(data: any, token: any) {
    return http.post("/ngo", data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getSingleNgo(id: any, token: any) {
    return http.get(`/ngo/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateNgo(data: any, id: any, token: any) {
    return http.patch(`/ngo/${id}`, data, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  deleteNgo(id: any, token: any) {
    return http.delete(`/ngo/${id}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  syncEHC(limit: any) {
    return http.get(`orca/assessments/wix/ehc?limit=${limit}`);
  }
}
export default new AssessmentDataService();
